module.exports = __webpack_public_path__ + "images/5d57d5075c90771014a54844da581ac5.jpg";